import React, { useState, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, LayersControl } from 'react-leaflet';
import { useEvacuationSpace } from '../api/useEvacuationSpace';
import { GeoLocation } from './GeoLocation';
import L, { Map as LeafletMap } from "leaflet";
import "leaflet/dist/leaflet.css";
import './Map.css';
import 'leaflet-routing-machine';
import 'leaflet/dist/leaflet.css';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import { CityLocations, DefaultLocation } from '../data/Locations';
import { MarkerData } from '../types/types';

L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

const MAP_ICON = L.icon({
  iconUrl: './images/leaflet/map_marker_icon.png',
  iconSize: [80, 80],
  iconAnchor: [12, 41],
  popupAnchor: [0, -30],
});

const FloodIcon = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 20C2 20 6 14 10 18C14 22 18 16 22 20C26 24 30 18 30 18" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 26C2 26 6 20 10 24C14 28 18 22 22 26C26 30 30 24 30 24" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 18L16 6L28 18" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 16V24" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24 16V24" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 20H18" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Map = () => {
  const [position, setPosition] = useState<[number, number]>(DefaultLocation);
  const [zoom, setZoom] = useState<number>(13);
  const markerData: MarkerData[] = useEvacuationSpace();
  const mapRef = useRef<LeafletMap | null>(null);
  const [showFloodMap, setShowFloodMap] = useState(true);

  const handleLocationChange = (newLocation: [number, number]) => {
    if (newLocation === null || (newLocation[0] === 0 && newLocation[1] === 0)) return;
    setPosition(newLocation);
    if (mapRef.current) {
      mapRef.current.setView(newLocation);
    }
  };

  const updatedAt = markerData[0] ? markerData[0].updated_at : '';
  const attribution = `安芸高田市避難所マップ<br/>最終更新日:${updatedAt}<br/>&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors<br/>&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html">地理院タイル</a>`;

  return (
    <>
      <MapContainer ref={mapRef} center={position} zoom={zoom} scrollWheelZoom={false}>
        <TileLayer
          attribution={attribution}
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {showFloodMap && (
          <TileLayer
            url="https://disaportaldata.gsi.go.jp/raster/01_flood_l2_shinsuishin_data/{z}/{x}/{y}.png"
            opacity={0.7}
          />
        )}
        {
          markerData.map((data, index) => (
            <Marker key={index} position={[data.lat, data.long]} icon={MAP_ICON}>
              <Popup>
                <div>
                  <h3>{data.name}</h3>
                  <p>{data.address}</p>
                  <p><a href={`tel:${data.tel}`} className="tel">{data.tel}</a></p>
                  {data.otasuke_phone && <p>お助けフォン：{data.otasuke_phone}</p>}
                  <p>{data.capacity}人</p>
                </div>
              </Popup>
            </Marker>
          ))
        }
        <div className="hazard-map-control">
          <button onClick={() => setShowFloodMap(!showFloodMap)}>
            {showFloodMap ? '洪水マップ非表示' : '洪水マップ表示'}
          </button>
        </div>
      </MapContainer>
      <GeoLocation onLocationChange={handleLocationChange} />
      <div className="location-button-wrap">
        {
          CityLocations.map((data, index) => (
            <div className="button-wrap" key={index}>
              <button onClick={() => {
                if (mapRef.current) {
                  mapRef.current.setView([data.lat, data.long]);
                }
              }}>{data.name}</button>
            </div>
          ))
        }
      </div>
    </>
  );
};

export default Map;